export default __webpack_public_path__ + "static/media/mytm-login-bg.ad54edba.png";